<template>
  <div>
    <div class="container-fluid">
      <Toast position="top-right" group="tr" />
      <div class="d-flex">
      <div class="carousel-indicators">
        <button :class="step >= 1? 'active px-2 my-auto mx-3 btn slide-btn':'px-2 my-auto mx-3 btn slide-btn'">
          Workers
        </button>
        <button :class="step - 1 >= 3? 'active px-2 my-auto mx-3 btn slide-btn':'px-2 my-auto mx-3 btn slide-btn'">
          Branches
        </button>
        <button :class="step - 1 >= 4? 'active px-2 my-auto mx-3 btn slide-btn':'px-2 my-auto mx-3 btn slide-btn'">
          Buses
        </button>
        <button :class="step - 1 >= 5? 'active px-2 my-auto mx-3 btn slide-btn':'px-2 my-auto mx-3 btn slide-btn'">
          Routes
        </button>
      </div>
      <router-link to="/admin/dashboard" id="back-to-dash">Back to dashboard <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="rgba(255,255,255,1)"/></svg> </router-link>
      </div>
      <div v-show="step === 1">
        <Shaloi @sendShalois="getShalois($event)" />
      </div>
      <div v-show="step === 2">
        <Drivers @sendDrivers="getDrivers($event)" />
      </div>
      <div v-show="step === 3">
        <Providers />
      </div>
      <div v-show="step === 4">
        <Branches :shalois="shalois" />
      </div>
      <div v-show="step === 5">
        <Buses :Drivers="Drivers" />
      </div>
      <div v-show="step === 6">
        <Routes />
      </div>
      <div class="action-btns d-flex flex-wrap mx-auto mb-3">
        <button
          @click.prevent="prev()"
          id="cancel"
          class="btn col-5 col-sm-5 col-md-4 col-lg-2 mx-2"
        >
          Previous
        </button>
        
        <button
        v-if="step<6"
          @click.prevent="next()"
          id="next"
          class="btn col-6 col-sm-5 col-md-4 col-lg-2 text-white ml-2"
        >
          Next
        </button>
        <router-link
        v-else
          to="/admin/dashboard"
          id="next"
          class="btn col-6 col-sm-5 col-md-4 col-lg-2 text-white ml-2"
        >
          Continue to dashboard
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import Branches from "./components/branches";
import Buses from "./components/buses";
import Drivers from "./components/Drivers";
import Shaloi from "./components/shalois";
import Providers from "./components/Providers";
import jwt_decode from "jwt-decode";
import Routes from "./components/routesregistration";
import Confirmation from "./components/ConfirmationCompanyReg";
import router from "../../router/index";
export default {
  components: {
    Routes,
    Confirmation,
    Branches,
    Buses,
    Drivers,
    Providers,
    Shaloi,
  },
  data() {
    return {
      shalois: [],
      step: 1,
      Drivers: [],
      url: null,
    };
  },
  created() {

    const token = localStorage.getItem("jwt");
    const decoded = jwt_decode(token);
    const userRole = decoded.role;
    if ( userRole != "admin") {
      return router.push("/dashboard");
    }
          
  },
  methods: {
    prev() {
      if (this.step > 1) {
        this.step--;
      }
    },
     getDrivers(data) {
      this.Drivers = data;
    },
    getShalois(data) {
      this.shalois = data;
    },
    next() {
      if (this.step < 6) {
        this.step++;
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      return router.push("/admin/dashboard");
    },
  },
};
</script>
<style lang="scss" scoped>
.carousel-indicators {
  position: relative;
  margin-top: 0.5em;
  margin-bottom: 0;
  width: 100%;
}
.form {
  position: relative;
}
.action-btns {
  height: fit-content;
  display: flex;
  justify-content: center;
  position: relative;
  left: 0;
  right: 0;
  margin-bottom: 0.5em !important;
}

#cancel {
  color: white;
  background-color: #6c757d !important;
  height: 40px;
  padding: 2px 10px;
  font-size: 12px;
  min-width: fit-content;
}
.slide-btn {
  font-size: 12px;
  border-radius: 2.5px !important;
  color: #0069d9;
  width: 10%;
  min-width: fit-content;
  height: 35px;
  border: 1px solid #0069d9;
  background: white;
}
#next,button.active {
    background-color: #0069d9;
    color: white !important;
}
#back-to-dash{
  background: #123a64;
  color: white !important;
  display: flex;
  justify-content: center;
  width: 15%;
  padding: 4px 0.5em;
  min-width: fit-content;
  align-items: center;
  height: 35px !important;
  font-size: 14px;
  margin-top: 0.5em;
  border-radius: 5px;
}

@media only screen and (max-width: 750px) {
  .carousel-indicators {
    display: none;
  }
}
</style>
